import { Dispatch, SetStateAction, useState } from 'react';
import { singletonHook } from 'react-singleton-hook';
import { homePage, TileImage } from 'api/home-page';

export class ThumbnailLoader {
    private imageCache: { [key: string]: string } = {};

    private imageLoadQueue: { [key: string]: string[] } = {};
    private imageLoadRequested: { [key: string]: string[] } = {};
    private isInLoad: { [key: string]: boolean } = {};
    private bulkSize: number = 5;

    public loadImages = (element_type: string): void => {
        if (undefined === this.isInLoad[element_type]) this.isInLoad[element_type] = false;

        if (!this.isInLoad[element_type] && this.imageLoadQueue[element_type].length > 0) {
            this.isInLoad[element_type] = true;

            let ids: string[] = [];
            let lng = this.imageLoadQueue[element_type].length;
            while (lng--) {
                let key = this.imageLoadQueue[element_type][lng];
                if (document.getElementsByClassName('thumbnail_' + key).length > 0) {
                    ids.push(key);
                    this.imageLoadRequested[element_type].push(key);
                    this.imageLoadQueue[element_type].splice(lng, 1);

                    if (ids.length >= this.bulkSize) break;
                }
            }

            if (0 == ids.length) {
                let i = 0;
                while (this.imageLoadQueue[element_type].length > 0) {
                    if (i >= this.bulkSize) break;
                    i++;
                    let key = this.imageLoadQueue[element_type].shift();
                    if (undefined !== key) {
                        ids.push(key);
                        this.imageLoadRequested[element_type].push(key);
                    }
                }
            }

            homePage.loadTileImages(ids).then((data) => {
                for (let i = 0; i < data.length; i++) {
                    let key = data[i].user_dashboard_element_instance_id;
                    if (data[i].thumb_src > '') {
                        this.imageCache[key] = data[i].thumb_src;
                    } else {
                        this.imageCache[key] = '/img/default_thumbnail.svg';
                    }

                    let elements = document.getElementsByClassName('thumbnail_' + key);
                    for (const element of elements) {
                        element.setAttribute('src', this.imageCache[key]);
                    }
                }

                this.isInLoad[element_type] = false;
                this.loadImages(element_type);
            });
        }
    };

    public getImage = (key: string, element_type?: string): string => {
        if (undefined !== this.imageCache[key]) return this.imageCache[key];
        if (undefined == element_type) element_type = '';
        if (undefined === this.imageLoadRequested[element_type]) this.imageLoadRequested[element_type] = [];
        if (undefined === this.imageLoadQueue[element_type]) this.imageLoadQueue[element_type] = [];

        if (
            !(
                this.imageLoadRequested[element_type].indexOf(key) >= 0 ||
                this.imageLoadQueue[element_type].indexOf(key) >= 0
            )
        ) {
            this.imageLoadQueue[element_type].push(key);
            this.loadImages(element_type);
        }

        return '/img/default_thumbnail_temporary.png';
    };

    public clearImagesQueue = (): void => {
        for (const element_type in this.imageLoadQueue) {
            this.imageLoadQueue[element_type] = [];
        }

        for (const element_type in this.imageLoadRequested) {
            this.imageLoadRequested[element_type] = [];
        }

        for (const element_type in this.isInLoad) {
            this.isInLoad[element_type] = false;
        }
    };
}

const thumbnailLoader = new ThumbnailLoader();

export const useThumbnailLoader = singletonHook<ThumbnailLoader>(thumbnailLoader, () => {
    const [tl, setMode] = useState<ThumbnailLoader>(thumbnailLoader);
    return tl;
});
